var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toasts",attrs:{"aria-live":"polite"}},[_c('transition-group',{attrs:{"name":"toast"}},_vm._l((_vm.toasts),function(t){return _c('div',{key:t.id,staticClass:"toast",class:t.type},[_vm._v(_vm._s(t.text))])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }